import {
  FETCH_SHOP_INFO_REQUEST_STARTED,
  FETCH_SHOP_INFO_REQUEST_FAILED,
  FETCH_SHOP_INFO_REQUEST_SUCCESS,
} from '../types'

const initialState = {
  isLoading: true,
  contactEmail: null,
  currencyCode: 'USD',
}

const reducers = {}

reducers[FETCH_SHOP_INFO_REQUEST_STARTED] = state => {
  return Object.assign({}, state, {
    isLoading: true,
  })
}

reducers[FETCH_SHOP_INFO_REQUEST_FAILED] = state => {
  return Object.assign({}, state, {
    isLoading: false,
  })
}

reducers[FETCH_SHOP_INFO_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action

  const { shop } = payload

  return Object.assign({}, state, {
    currencyCode: shop.currencyCode,
    contactEmail: shop.contactEmail,
    isLoading: false,
  })
}

export default function reducer(state = initialState, action) {
  const found = reducers[action.type]
  if (found) return found(state, action)
  return state
}
